// extracted by mini-css-extract-plugin
export var dark = "fullColumnImageCta-module--dark--d3e77";
export var fadeInUpGrid = "fullColumnImageCta-module--fadeInUpGrid--37194";
export var fullColumnImageCtaImage = "fullColumnImageCta-module--fullColumnImageCtaImage--b77cb";
export var integrationCtaWrapper = "fullColumnImageCta-module--integrationCtaWrapper--eeb5f";
export var light = "fullColumnImageCta-module--light--29d59";
export var styledWrapper = "fullColumnImageCta-module--styledWrapper--8d4e5";
export var title = "fullColumnImageCta-module--title--6a656";